var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-badge border-box",class:`p-badge--${_vm.badge.color}`},[_c('span',{staticClass:"p-badge--content",class:{ 'gray--text text--darken-3': _vm.dot }},[(_vm.dot)?_c('div',{staticClass:"dot",class:_vm.badge.dotColor}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }